module.exports = __webpack_public_path__ + "static/Puas-31c2c81b5db9931d22222010a3a05a88.png";